var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOvernatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "currentColor",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26.015 26.015c5.894-5.894 5.894-15.45 0-21.343-5.894-5.894-15.45-5.894-21.343 0-5.894 5.893-5.894 15.45 0 21.343 5.893 5.894 15.45 5.894 21.343 0zm-4.573-2.633l2.138 2.138c-5.142 4.172-12.709 3.865-17.494-.92-4.784-4.785-5.09-12.352-.92-17.493l5.669 5.668-5.303 10.607h15.91zm.114-2.716l-5.86-5.86v-5.86l5.86 11.72zm2.715 2.716h.197L15 4.445l-3.222 6.444-5.236-5.237C11.68.978 19.637 1.123 24.6 6.086c4.963 4.964 5.108 12.921.434 18.059l-.763-.763zm-12.4-9.57l2.434 2.433v5.746H7.782l4.09-8.18zm3.824 3.823v4.356h4.356l-4.356-4.356zm-2.88-5.71l1.49-2.98v4.47l-1.49-1.49z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOvernatting);
export default __webpack_public_path__ + "static/media/icon-overnatting.816450fe.svg";
export { ForwardRef as ReactComponent };